// Generated by ReScript, PLEASE EDIT WITH CARE


var successResponse = {
    penalty_enums: [
      {
        id: 2,
        name: "My driver asked me to cancel",
        description: "My driver asked me to cancel"
      },
      {
        id: 2,
        name: "My driver asked me to cancel",
        description: "My driver asked me to cancel"
      }
    ],
    order_id: "CRN00000000",
    order_time: 1646942846000,
    driver_name: "Test Driver",
    msisdn: "000000000000",
    vehicle_type: "1 Ton 7 Feet",
  };

export {
  successResponse ,
  
}
/* No side effect */
